"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useReducer } from "react";
import { formatCountdown } from "@/utils/timeFormatters";

/**
 * Hook that provides auto-updating countdown text
 * @param targetTime Future timestamp in milliseconds or null
 * @returns Formatted string that updates periodically
 */
export function useCountdown(targetTime) {
  const $ = _c(7);
  const [, forceUpdate] = useReducer(_temp, 0);
  let t0;
  if ($[0] !== forceUpdate || $[1] !== targetTime) {
    t0 = () => {
      if (targetTime === null || Date.now() >= targetTime) {
        return;
      }
      const getUpdateInterval = function getUpdateInterval() {
        if (targetTime === null) {
          return 0;
        }
        const timeRemaining = targetTime - Date.now();
        if (timeRemaining < 3600000) {
          return 60000;
        }
        if (timeRemaining < 86400000) {
          return 300000;
        }
        return 3600000;
      };
      const intervalTime = getUpdateInterval();
      const interval = setInterval(() => {
        if (Date.now() >= targetTime) {
          clearInterval(interval);
        }
        forceUpdate();
      }, intervalTime);
      return () => clearInterval(interval);
    };
    $[0] = forceUpdate;
    $[1] = targetTime;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== targetTime) {
    t1 = [targetTime];
    $[3] = targetTime;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== targetTime) {
    t2 = formatCountdown(targetTime);
    $[5] = targetTime;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(x) {
  return x + 1;
}